import type { GameContent } from '../../../shared/game/world-types.js';

const lit = new Map<string, boolean>();

/** Whether a prop's lights burn, by `MapProp.id`. A prop that is not usable keeps the look it is drawn with. */
export const propLit = (id: string | undefined) => id === undefined || (lit.get(id) ?? true);

/** Presentation only: takes the usable props' states from a snapshot. A prop it leaves out shows its initial state. */
export function showPropStates(content: GameContent, states: Record<string, string>) {
  for (const prop of content.usableProps ?? []) lit.set(prop.id, prop.states.find(state => state.id === (states[prop.id] ?? prop.initial))?.lit === true);
}
